import './FeedOnlineModel.sass';

import React, { FC, useCallback, useEffect } from 'react';

import { FeedOnlineModelProps } from './FeedOnlineModel.interface';
import { Block, Button } from '$uikit';
import router from '$navigation/router';
import { statReachGoal } from '$utils';

export const FeedOnlineModel: FC<FeedOnlineModelProps> = ({ object }) => {
  const { coverUrl, coverThumbnail, title, caption, link, actionText, kind, userId } =
    object;

  useEffect(() => {
    statReachGoal('feed_online_model_block', {
      kind,
      userId,
    });
  }, [kind, userId]);

  const handleClick = useCallback(() => {
    const parsed = router.matchUrl(link);
    if (parsed && !link.match('https')) {
      router.navigate(parsed.name, parsed.params);
    } else {
      window.open(link, '_blank');
    }
    statReachGoal('feed_online_model_block_click', {
      kind,
      userId,
    });
  }, [link, kind, userId]);

  return (
    <Block className="FeedOnlineModelProps" onClick={handleClick}>
      <div
        className="FeedOnlineModelProps__cover"
        style={{
          backgroundImage: `url(${coverUrl}), url(${coverThumbnail})`,
        }}
      />
      <div className="FeedOnlineModelProps_cont">
        <div className="FeedOnlineModelProps__title">{title}</div>
        <div className="FeedOnlineModelProps__caption">{caption}</div>
        <div className="FeedOnlineModelProps__action">
          <Button>{actionText}</Button>
        </div>
      </div>
    </Block>
  );
};
